<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <div class="two-factor-authentication">
                <h2 class="title">Autenticação de Dois Fatores</h2>
                <p class="instruction">Abra o seu aplicativo do Google Authenticator e insira o código de verificação do Pedbot</p>
                    <vs-input type="text" id="inputTwoFactor" class="w-full" required placeholder="Código de 6 digitos" v-model="googleSecret" @keyup.enter="validate"/>
                    <vs-button color="primary" class="button w-full" @click="validate">Enviar Código</vs-button>
            </div>
        </div>
    </div>
</template>
<script>

import { formatRouteTenantPath, getIp } from '@/utils'
import user from '@/http/requests/user'

export default {
  data() {
    return {
      googleSecret: '',
    }
  },
  methods:{
    async validate(){
      const numericRegex = /^[0-9]+$/;
        if (!numericRegex.test(this.googleSecret)) {
          this.$vs.notify({
            title: 'Erro',
            text: 'O código deve ser apenas numérico.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
          return;
        }
      try {
        if (this.googleSecret) {
          const ip = await getIp()
          this.$store.dispatch('user/twoFactorActivity', {validate: this.googleSecret, identify: 1, ip: ip})
          .then(response => {
              this.$vs.notify({
                title: 'Autenticação em 2 Fatores',
                text: 'Token Validado',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success',
              });

              this.$store.dispatch('user/infos').then( () => {
                this.$router.push(formatRouteTenantPath('/instances/list/choose-instance')).then( () => window.location.reload() );
                user.connected(ip)
              })
            }
          )
        }
      } catch (error) {
        user.disconnected(ip)
        console.error('Ocorreu um erro ao validar a chave secreta:', error);
      }
    },
  }, 
}

</script>
  
  <style>
  .two-factor-authentication {
    max-width: 400px;
    margin: auto;
    position: absolute; 
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: #f9f9f9;
    border-color: #716e6e;
  }
  
  .title {
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
  }
  
  .form {
    display: flex;
    flex-direction: column;
  }
  
  .label {
    font-size: 16px;
    margin-bottom: 8px;
  }
  
  #inputTwoFactor {
    padding: 8px;
    font-size: 16px;
    margin-bottom: 16px;
    border: 1px solid #716e6e;
    border-radius: 4px;
  }
  
  .button {
    padding: 10px 20px;
    font-size: 16px;
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .button:hover {
    background-color: #0056b3;
  }

  .instruction {
    text-align: center;
    color: black;
    font-weight: 430;
    margin-bottom: 40px;
   }
  </style>
  